var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "title": "导入工资数据",
      "visible": _vm.visible,
      "confirm-loading": _vm.confirmLoading,
      "mask-closable": false,
      "width": 800
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('div', {
    staticClass: "download-template-section",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v("下载模板：")]), _c('a-button', {
    attrs: {
      "type": "link"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadTemplate('salary');
      }
    }
  }, [_vm._v("工资总表模板")]), _c('a-divider', {
    attrs: {
      "type": "vertical"
    }
  }), _c('a-button', {
    attrs: {
      "type": "link"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadTemplate('performance');
      }
    }
  }, [_vm._v("奖励性绩效明细表模板")])], 1), _c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "学部"
    }
  }, [_c('a-select', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['department', {
        rules: [{
          required: true,
          message: '请选择学部!'
        }],
        initialValue: ''
      }],
      expression: "[\n          'department',\n          { \n            rules: [{ required: true, message: '请选择学部!' }],\n            initialValue: ''\n          }\n        ]"
    }],
    attrs: {
      "placeholder": "请选择学部"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "小学部"
    }
  }, [_vm._v("小学部")]), _c('a-select-option', {
    attrs: {
      "value": "初中部"
    }
  }, [_vm._v("初中部")]), _c('a-select-option', {
    attrs: {
      "value": "高中部"
    }
  }, [_vm._v("高中部")])], 1)], 1), _c('a-form-item', {
    attrs: {
      "label": "工资月份"
    }
  }, [_c('a-month-picker', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['salaryMonth', {
        rules: [{
          required: true,
          message: '请选择工资月份!'
        }],
        initialValue: null
      }],
      expression: "[\n          'salaryMonth',\n          { \n            rules: [{ required: true, message: '请选择工资月份!' }],\n            initialValue: null\n          }\n        ]"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择工资月份",
      "value-format": "YYYY-MM"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "工资标题"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['salaryTitle', {
        rules: [{
          required: true,
          message: '请输入工资标题!'
        }],
        initialValue: ''
      }],
      expression: "[\n          'salaryTitle',\n          { \n            rules: [{ required: true, message: '请输入工资标题!' }],\n            initialValue: ''\n          }\n        ]"
    }],
    attrs: {
      "placeholder": "请输入工资标题"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "工资总表"
    }
  }, [_c('a-upload-dragger', {
    attrs: {
      "file-list": _vm.salaryTotalFileList,
      "remove": _vm.handleSalaryTotalRemove,
      "before-upload": _vm.beforeSalaryTotalUpload,
      "accept": ".xlsx,.xls",
      "show-upload-list": true,
      "max-count": 1
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("点击或拖拽文件到此处上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v("支持格式：.xlsx, .xls")])])], 1), _c('a-form-item', {
    attrs: {
      "label": "奖励性绩效明细表"
    }
  }, [_c('a-upload-dragger', {
    attrs: {
      "file-list": _vm.performanceDetailFileList,
      "remove": _vm.handlePerformanceDetailRemove,
      "before-upload": _vm.beforePerformanceDetailUpload,
      "accept": ".xlsx,.xls",
      "show-upload-list": true,
      "max-count": 1
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("点击或拖拽文件到此处上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v("支持格式：.xlsx, .xls")])])], 1)], 1), _c('template', {
    slot: "footer"
  }, [_c('a-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmLoading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("导入并校验")])], 1), _c('div', {
    staticClass: "import-rules"
  }, [_c('h4', [_vm._v("导入规则说明：")]), _c('ol', [_c('li', [_vm._v("导入前请确保已选择正确的学部和工资月份，导入后将无法修改")]), _c('li', [_vm._v("系统将自动校验文件中身份证号码的有效性，无效身份证将生成反馈文件")]), _c('li', [_vm._v("相同学部和月份的工资条重复导入时，将自动覆盖历史数据")]), _c('li', [_vm._v("导入成功后可在\"导入记录\"中查看并发送工资条")])])])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };